import callApi from './eventActivtiyService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/activity-reserve`;

export const getEventActivityMemberList = (query) => callApi({
    method: 'GET',
    endpoint: `${basePath}/sa?${query}`
  });
export const getActivityDropdown = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/activity/dropdown/${id}`
  });
export const getActivityTimeList = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/period/${id}`
  });
export const getEditData = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/sa/${id}`
  });
export const sendEventActivity = (data) => callApi({
    method: 'POST',
    endpoint: `${basePath}/sa`,
    body: data
});
export const cancelEventActivity = (id) => callApi({
    method: 'PATCH',
    endpoint: `${basePath}/status/${id}/cancel`
});
export const getMemberInfo = (line_uuid) => callApi({
    method: 'GET',
    endpoint: `${basePath}/chat-user/${line_uuid}`
});
export const editEventActivity = ({ id, input }) => callApi({
    method: 'PUT',
    endpoint: `${basePath}/sa/${id}`,
    body: input
});
export const successEventActivity = (id) => callApi({
    method: 'PATCH',
    endpoint: `${basePath}/status/${id}/success`
});
